// extracted by mini-css-extract-plugin
export default {"Page":"index_Page__tH3u7","PageHd":"index_PageHd__GX-Lj","Form":"index_Form__BiPBo","BtnSubmitWrap":"index_BtnSubmitWrap__K6jle","BtnSubmit":"index_BtnSubmit__hqaOf"};